import { useState } from 'react';
import { Box } from '@mui/material';
import PageHeader from '../../../components/PageHeader';
import StyledDataGrid from '../../../components/StyledDataGrid';
import WorkspacePage from '../../../components/WorkspacePage';

const BioBankChain = () => {
  const [rows] = useState([
    { id: 1, bioBankID: 'BB001', bankName: 'BioBank A', contact: 'contactA@example.com', purpose: 'Research A', scope: 'National', location: 'USA' },
    { id: 2, bioBankID: 'BB002', bankName: 'BioBank B', contact: 'contactB@example.com', purpose: 'Research B', scope: 'International', location: 'Germany' },
  ]);

  const columns = [
    { field: 'bioBankID', headerName: 'BioBank ID', flex: 1 },
    { field: 'bankName', headerName: 'Bank Name', flex: 1 },
    { field: 'contact', headerName: 'Contact', flex: 1 },
    { field: 'purpose', headerName: 'Purpose', flex: 2 },
    { field: 'scope', headerName: 'Scope', flex: 1 },
    { field: 'location', headerName: 'Location', flex: 1 },
  ];

  const shouldPaginate = rows.length > 5;

  return (
    <WorkspacePage>
      <PageHeader title="BioBank Chain" />
      <Box sx={{ flex: 1, minHeight: 0, width: '100%', overflowX: 'auto' }}>
        <StyledDataGrid
          rows={rows}
          columns={columns}
          pageSizeOptions={[10, 25, 50, 100]}
          pagination={shouldPaginate}
          autoHeight
          disableSelectionOnClick
          sx={{
            '& .MuiDataGrid-columnHeaders': { backgroundColor: '#f5f5f5' }
          }}
        />
      </Box>
    </WorkspacePage>
  );
};

export default BioBankChain;
